import {
  ResourceType,
  SavingsOpportunityType,
} from "@/services/cloudchipr.api";
import { opportunityTypeTitlesByActionType } from "@/components/pages/savings-opportunities/utils/constants/common";
import { getResourceTypeName } from "@/utils/helpers/resources/getResourceTypeName";

export const getSavingsOpportunityName = (
  actionType?: SavingsOpportunityType,
  service?: ResourceType,
) => {
  const actionName = actionType
    ? opportunityTypeTitlesByActionType[actionType]
    : "";
  const serviceName = service
    ? getResourceTypeName(service, {
        type: "long",
        singular: true,
      })
    : "";

  if (actionType === "live_filtered_resource") {
    return `Delete ${actionName} ${serviceName}`;
  }

  if (actionType === "off_hours") {
    return `${actionName} for ${serviceName}`;
  }

  if (actionType === "migrate_to_graviton") {
    return `Migrate ${serviceName} to Graviton`;
  }

  if (actionType === "rightsizing") {
    return `Rightsize ${serviceName}`;
  }

  return `${actionName} ${serviceName}`;
};
